import {
  useGetUserStatus,
  useOpenUserStatusBottomSheet,
} from '@/userStatus/hooks';
import type { IFormSubmitButtonProps } from './FormSubmitButton.types';

interface IUseHandleSubmitBasedOnUserStatusParams
  extends Pick<
    IFormSubmitButtonProps,
    'onClick' | 'type' | 'forbiddenUserStatus'
  > {}

export const useHandleSubmitBasedOnUserStatus = ({
  forbiddenUserStatus,
  onClick,
  type,
}: IUseHandleSubmitBasedOnUserStatusParams) => {
  const { status } = useGetUserStatus();

  const openUserStatusBottomSheet = useOpenUserStatusBottomSheet();

  const isForbiddenStatus = forbiddenUserStatus?.includes(status);

  const handleClick = (e: TButtonEvent) => {
    if (isForbiddenStatus) {
      openUserStatusBottomSheet();
    } else {
      onClick?.(e);
    }
  };

  const selectedType: IFormSubmitButtonProps['type'] = isForbiddenStatus
    ? 'button'
    : type;

  return {
    handleClick,
    selectedType,
  };
};
